import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "../Layout/layout";
import Home from "../Components/home";
import Destination from "../Components/destination";
import DestinationDetail from "../Components/destinationDetail";
import Checkout from "../Components/checkout";
import PaymentSuccess from "../Components/PaymentSuccess";
import Blog from "../Components/blog";
import SpeedPolicy from "../Components/speedPolicy";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ContactUs from "../Components/contact";
import BlogDetail from "../Components/blogDetail";
import Faq from "../Components/faq";
import ActivateEsim from "../Components/activateEsim";
import Login from "../AdminComponents/auth/login";
import AdminLayout from "../AdminLayout/adminLayout";
import ForgotPassword from "../AdminComponents/auth/forgot";
import Dashboard from "../AdminComponents/pages/dashboard";
import ProtectedRoute from "../AdminComponents/auth/ProtectedRoute";
import Customers from "../AdminComponents/pages/customers";
import ViewCustomers from "../AdminComponents/pages/viewCustomers";
import ScrollToTop from "../Components/ScrollToTop";
import TermsAndConditions from "../Components/terms&conditions";
import PrivacyPolicy from "../Components/privacyPolicy";
import RefundPolicy from "../Components/refundPolicy";
import WhatIsAnEsim from "../Components/whatIsEsim";
import AdminBlog from "../AdminComponents/pages/blogs";
import ViewBlog from "../AdminComponents/pages/viewBlog";
// import HomePage from "../Components/hometest";
import Partnerships from "../Components/partnerships";
import CookiesPolicy from "../Components/cookiesPolicy";
import CookiesSetting from "../Components/cookiesSetting";
import TermsOfUse from "../Components/termsOfUse";
import DataCalculator from "../Components/dataCalculator";
export default function AppRoutes() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          pauseOnHover
          draggable
        />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="destination" element={<Destination />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blogDetail/:blog_id" element={<BlogDetail />} />
            <Route path="speedPolicy" element={<SpeedPolicy />} />
            <Route path="Faq" element={<Faq />} />
            <Route path="activateEsim" element={<ActivateEsim />} />
            <Route path="contactUs" element={<ContactUs />} />
            <Route path="esim" element={<WhatIsAnEsim />} />
             <Route path="terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="partnerships" element={<Partnerships />} />
             <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="cookies-policy" element={<CookiesPolicy />} />
              <Route path="cookies-settings" element={<CookiesSetting />} />
               <Route path="terms-of-use" element={<TermsOfUse />} />
               <Route path="data-calculator" element={<DataCalculator />} />

             <Route path="refund-policy" element={<RefundPolicy />} />
            <Route path="destination-detail/:iso3" element={<DestinationDetail />} />
          </Route>
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="login" element={<Login />} />
            <Route path="forgotPassword" element={<ForgotPassword />} />
            <Route path="dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
             <Route path="customers" element={
              <ProtectedRoute>
                <Customers />
              </ProtectedRoute>
            } />
               <Route path="blogs" element={
              <ProtectedRoute>
                <AdminBlog/>
              </ProtectedRoute>
            } />
               <Route path="viewBlog/:blog_id" element={
              <ProtectedRoute>
                <ViewBlog />
              </ProtectedRoute>
            } />
               <Route path="viewCustomers/:user_id" element={
              <ProtectedRoute>
                <ViewCustomers />
              </ProtectedRoute>
            } />
          </Route>
          
          <Route path="checkout" element={<Checkout />} />
          {/* <Route path="test" element={<HomePage />} /> */}

          <Route path="payment-success" element={<PaymentSuccess />} />
        </Routes>
      </BrowserRouter>
      {/* <ToastContainer /> */}
    </>
  );
}
